import { Button } from "PFCore/components/button";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./fill_button.module.scss";

const FillButton = ({ onClick, disabled }) => {
  const { t } = useTranslation("auditPlanner");

  return <Button text={t("fill")} rootClassName={css.button} onClick={onClick} disabled={disabled} />;
};

FillButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default FillButton;
